angular.module('unica_event_tag.event_tag_controllers', [])

.controller('EventTagBasicController',
	function(
		$rootScope, $scope, $stateParams,
		EventTagListService
	) {

	$scope.forms = {};

	$rootScope.eventTagData = {
		event_id: $stateParams.event_id,
	};

		$scope.$on('event_loaded', function() {
			$scope.year = $rootScope.year;
		});

	$rootScope.getEventTag = function(eventTagId)
	{
		$scope.showLoader();

		EventTagListService
			.get(eventTagId)
			.then(function(data) {
				$scope.hideLoader();

				$rootScope.eventTagData = data;
			});
	};



});


